import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import colors from 'vuetify/es5/util/colors';
import Vuetify from 'vuetify'

// index.js or main.js
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

import AppPageHeader from '@/views/layout/AppPageHeader.vue'
import AppLoader from '@/components/Loader'

Vue.component('app-page-header', AppPageHeader)
Vue.component('app-loader', AppLoader)

Vue.config.productionTip = false

Vue.use(Vuetify, {
  /*theme: {
    primary: colors.blue.darken3,
    secondary: colors.blue.darken2,
    tertiary: colors.indigo.lighten2,
    accent: colors.indigo.base,
    quaternary: colors.brown.lighten1
    
  }*/
  theme: {
    primary: colors.teal.darken3,
    secondary: colors.teal.darken2,
    tertiary: colors.teal.lighten2,
    accent: colors.teal.base,
    quaternary: colors.brown.lighten1
    
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth) && (!store.getters.user.access_token || store.getters.user.access_token === '')) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if ( (to.name == 'login' || to.name == 'passwordResetRequest' || to.name == 'passwordReset') && store.state.user.access_token) {
    router.push({
      name: 'pregled'
    })
  } else if(to.path == '/') {
    router.push({
      name: 'pregled'
    })
  } else {
      next()
  }
})

// Check local storage to handle refreshes
if (window.localStorage) {
  var user = JSON.parse(window.localStorage.getItem('app_supernova')) || null
  if ( (user && store.state.user.id !== user.id) && (user.access_token && store.state.user.access_token !== user.access_token) ) {
    store.commit('SET_USER', user)
  }
}

//event bus
export const EventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
